module.exports = __webpack_public_path__ + "static/media/My-Holds-White.7a8a7f80.svg";